import { Button, Heading, Modal } from "react-bulma-components";
import { CancelButton, RemoveCardSection } from "../Components";

import ExclamationCircle from "static/svg/exclamation-circle";
import Loader from "components/Loader";
import { useTranslation } from "react-i18next";

interface RemoveCardModalProps {
  open: boolean;
  onClose: () => void;
  onRemove: () => void;
  loading: boolean;
  error: boolean;
}

export const RemoveCardModal = ({
  open,
  onClose,
  onRemove,
  loading,
  error
}: RemoveCardModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal show={open} onClose={onClose}>
      <Modal.Card>
        <Modal.Card.Head onClose={onClose}>
          <Modal.Card.Title />
        </Modal.Card.Head>

        <Modal.Card.Body>
          <RemoveCardSection>
            <ExclamationCircle width={64} />

            <Heading className="mb-2" size={5}>
              {t("billing_remove_card_modal_sub_title")}
            </Heading>

            <Heading className="mt-2 has-text-grey" size={6}>
              {t("billing_remove_card_modal_description")}
            </Heading>

            {loading ? (
              <Loader />
            ) : (
              <Button className="mt-2" color="danger" onClick={onRemove}>
                {t("billing_remove_card_modal_remove_button_title")}
              </Button>
            )}

            <CancelButton onClick={onClose}>
              {t("billing_remove_card_modal_cancel_button_title")}
            </CancelButton>

            {error && (
              <Heading className="mt-2 has-text-danger" size={6}>
                {t("billing_remove_card_modal_generice_error")}
              </Heading>
            )}
          </RemoveCardSection>
        </Modal.Card.Body>
      </Modal.Card>
    </Modal>
  );
};
